import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
    useHistory
} from "react-router-dom";
import RouteUtils from '../../utils/routeUtils'


const styles = makeStyles(theme => ({
    tabs: {
        borderBottom: '1px solid #DADADA',
        borderTop: '1px solid #DADADA',
        position: 'sticky',
        zIndex: 10,
        backgroundColor: 'white',
        top: '95px',
        padding: 0,
        marginTop: '-14px',
        width: 'calc(100% + 40px)',
        marginLeft: -20,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            marginLeft: 0,
        },
    },
    tab: {
        fontFamily: 'Open Sans',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        listStyle: 'none',
        justifyContent: 'flex-end',
        fontSize: '14px',
        top: 95,
        fontFamily: 'Open Sans',
        position: 'sticky',
        backgroundColor: 'white',
        padding: '14px 0 5px',
        zIndex: 10,

        '& li': {
            cursor: 'pointer',
            borderRadius: 8,
            border: '1px solid #9A99A2',
            minWidth: 83,
            minHeight: 29,
            lineHeight: '150%',
            marginRight: 6,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    selected: {
        fontWeight: '700 !important',
        [theme.breakpoints.up('sm')]: {
            color: '#074589',
        },
        [theme.breakpoints.down('xs')]: {
            backgroundColor: '#074589',
            color: 'white'
        }
    }
}));

export default function MarketTypeFilter({marketFilter, onFilterChanged, league, gameTime}) {
    const classes = styles();
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));
    const history = useHistory();

    const leagueName = league.toLowerCase();

    const changeFilter = (filter) => {
        if (gameTime !== undefined) {
            history.push('/' + league + '/' + RouteUtils.getUrlMarketFilter(filter) + '/' + gameTime + '/');
        } else {
            history.push('/' + league + '/' + RouteUtils.getUrlMarketFilter(filter) + '/');
        }

        if (onFilterChanged) {
            onFilterChanged(filter);
        }
    }

    function isSelected(filter) {
        return filter === marketFilter ? classes.selected : "";
    }

    if (isLargeScreen) {
        return (
            <MarketsTabs 
                className={classes.tabs} value={marketFilter}
                onChange={(e, newValue) => changeFilter(newValue)}
            >
                {
                    (leagueName === 'mlb' || leagueName === 'nhl') &&
                    <MoneylineTab value={'2way'} label="MONEYLINE" className={isSelected('2way')}/>
                }
                {
                    leagueName === 'nhl' &&
                    <PuckLinesTab value={'puck_line'} label="PUCK LINES" className={isSelected('puck_line')}/>
                }
                {
                    leagueName === 'mlb' &&
                    <RunLinesTab value={'run_line'} label="RUN LINES" className={isSelected('run_line')}/>
                }
                {
                    leagueName !== 'mlb' && leagueName !== 'nhl' &&
                    <SpreadsTab value={'spread'} label="SPREADS" className={isSelected('spread')}/>
                }
                {
                    leagueName !== 'mlb' && leagueName !== 'nhl' &&
                    <MoneylineTab value={'2way'} label="MONEYLINE" className={isSelected('2way')}/>
                }
                <TotalsTab value={'total'} label="TOTALS" className={isSelected('total')}/>
            </MarketsTabs>
        );
    } else {
        return (
            <div className={classes.container}>
                {
                    (leagueName === 'nhl' || leagueName === 'mlb') &&
                    <li key={'moneyline'} onClick={() => changeFilter("2way")} className={isSelected('2way')}>Moneyline</li>
                }
                {
                    leagueName === 'nhl' &&
                    <li key={'puckLine'} onClick={() => changeFilter("puck_line")} className={isSelected('puck_line')}>Puck Lines</li>
                }
                {
                    leagueName === 'mlb' &&
                    <li key={'runLine'} onClick={() => changeFilter("run_line")} className={isSelected('run_line')}>Run Lines</li>
                }
                {
                    leagueName !== 'mlb' && leagueName !== 'nhl' &&
                    <>
                        <li key={'spread'} onClick={() => changeFilter("spread")} className={isSelected('spread')}>Spread</li>
                        <li key={'moneyline'} onClick={() => changeFilter("2way")} className={isSelected('2way')}>Moneyline</li>
                    </>
                }
                <li key={'total'} onClick={() => changeFilter("total")} className={isSelected('total')}>Total</li>
            </div>
        );
    }
}

const PuckLinesTab = withStyles((theme) => ({
    root: {
        minWidth: 71,
        padding: 0,
        marginRight: '55px',
        fontFamily: 'proxima-nova'
    },
}))(Tab);

const RunLinesTab = withStyles((theme) => ({
    root: {
        minWidth: 71,
        padding: 0,
        marginRight: '55px',
        fontFamily: 'proxima-nova'
    },
}))(Tab);

const SpreadsTab = withStyles((theme) => ({
    root: {
        minWidth: 71,
        padding: 0,
        marginRight: '55px',
        fontFamily: 'proxima-nova'
    },
}))(Tab);

const MoneylineTab = withStyles((theme) => ({
    root: {
        minWidth: 71,
        padding: 0,
        marginRight: '55px',
        fontFamily: 'proxima-nova'
    }
}))(Tab);

const TotalsTab = withStyles((theme) => ({
    root: {
        minWidth: 71,
        padding: 0,
        fontFamily: 'proxima-nova'
    }
}))(Tab);


const MarketsTabs = withStyles((theme) => ({
    flexContainer: {
        marginLeft: 300
    }
}))(Tabs);